import styled from '@emotion/styled';
import Image from 'next/image';

import { CheckWhite } from '@common/assets';

import { ProgressType, getProgressTheme } from './progressBarUtils';

const CHECK_ICON_SIZE = 16;

const Container = styled.div<{ $color: string; $borderColor: string }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $color }) => $color};
  border: ${({ $borderColor }) => `1px solid ${$borderColor}`};
  box-shadow: 1px 1.5px 1px 0px rgba(255, 255, 255, 0.5) inset;
  filter: drop-shadow(1px 2px 4px rgba(0, 0, 0, 0.2)) drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.2));
`;

type Props = {
  type: ProgressType;
};

export const CheckIcon = ({ type }: Props) => {
  const {
    checkIcon: { bgColor, borderColor },
  } = getProgressTheme(type);

  return (
    <Container $color={bgColor} $borderColor={borderColor}>
      <Image src={CheckWhite} height={CHECK_ICON_SIZE} width={CHECK_ICON_SIZE} alt="" />
    </Container>
  );
};
